import cookies from 'react-cookie';

const sessionCookieName = process.env.REACT_APP_CLIENT_FC_COOKIE_SESSION;
const expirationCookieName = process.env.REACT_APP_CLIENT_FC_COOKIE_EXPIRATION_NAME;
const flagCookieName = process.env.REACT_APP_CLIENT_FC_COOKIE_FLAG;
const cookieDomain = process.env.REACT_APP_CLIENT_FC_COOKIE_DOMAIN;
const cookieExpiration = process.env.REACT_APP_CLIENT_FC_COOKIE_EXPIRATION;

class Cookie {
  static cookieFormat(userID, token) {
    return {
      authenticated: {
        authenticator: 'authenticator:jwt',
        token,
        userId: userID,
      },
    };
  }

  static options() {
    if (!cookieDomain || cookieDomain === 'localhost') {
      return {
        secure: false,
      };
    }
    return {
      path: '/',
      expires: new Date(Date.now() + cookieExpiration * 1000),
      maxAge: cookieExpiration,
      secure: true,
      httpOnly: false,
      domain: cookieDomain,
    };
  }

  static setSession(userID, token) {
    cookies.save(sessionCookieName, this.cookieFormat(userID, token), this.options());
    cookies.save(expirationCookieName, cookieExpiration, this.options());
    cookies.save(flagCookieName, true, this.options());
  }

  static getCountry() {
    let country = cookies.load('country_code');
    if (!country) {
      country = 'US';
    }
    return country;
  }

  static getUtms() {
    const utms = cookies.load('fc_utm');
    const fcUtms = {};
    if (utms) {
      utms.split(';').forEach(value => {
        const tmp = value.split('=');
        fcUtms[tmp[0]] = tmp[1];
      });
    }
    return fcUtms;
  }

  static getClickRef() {
    return cookies.load('clickref');
  }

  static getAffiliateId() {
    return cookies.load('aff_id');
  }

  // methods to get Iterable ids for tracking purchases
  static getCampaignId() {
    const campaign = cookies.load('iterableEmailCampaignId');
    return campaign ? parseInt(campaign, 10) : null;
  }

  static getTemplateId() {
    const template = cookies.load('iterableTemplateId');
    return template ? parseInt(template, 10) : null;
  }

  static clear() {
    cookies.remove('country_code', this.options());
    cookies.remove(sessionCookieName, this.options());
    cookies.remove(expirationCookieName, this.options());
    cookies.remove(flagCookieName, this.options());
  }
}

export default Cookie;
